import { default as WidgetContainer } from "./WidgetContainer";
import { default as PopupcardWidget } from "./PopupCard";

export const Widget = WidgetContainer;
export const PopupCard = PopupcardWidget;
